module.exports = __webpack_public_path__ + "img/two-parts.d088feea.jpg";